import styled from 'styled-components';

import { colors, media, PRIMARY_FONT_FAMILY } from '../../App/ChakraTheme';


export const NavItem = styled.div<any>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &.hide-desktop {
    @media (min-width: ${media.sizes.tabletLandscape}px) {
      display: none;
    }
  }
  &.hide-laptop-desktop {
    @media (min-width: ${media.sizes.laptop}px) {
      display: none;
    }
  }
  &.hide-tablet-landscape {
    @media (max-width: ${
      media.sizes.tabletLandscape - 0.02
    }px) and (min-width: ${media.sizes.tablet}px) {
      display: none;
    }
  }
  &.hide-laptop {
    @media (max-width: ${
      media.sizes.laptop - 0.02
    }px) and (min-width: ${media.sizes.tablet}px) {
      display: none;
    }
  }
  &.hide-tablet {
    @media (max-width: ${media.sizes.tablet - 0.02}px) and (min-width: ${
  media.sizes.phone
}px) {
      display: none;
    }
  }
  &.hide-phone {
    @media (max-width: ${media.sizes.phone - 0.02}px) {
      display: none;
    }
  }

  &.logo {
    margin-right: 56px;
  }

  & a.nav-link {
    fontFamily: ${PRIMARY_FONT_FAMILY},
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    fontSize: '15px',
    lineHeight: 2.13,
    letterSpacing: 'normal',

    text-decoration: none;
    color: ${colors.darkblue};
    transition: color 0.2s cubic-bezier(0, 0, 0.2, 1);
  }
  & .nav-link:hover {
    color: ${colors.steel};
  }

  & .subpage-caption {
    color: ${colors.midnight};
    opacity: 0.7;
    text-decoration: none;
    transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1);
    cursor: pointer;
  }
  & .subpage-caption:hover {
    opacity: 1;
  }
  &.active .subpage-caption {
    opacity: 1;
  }
  & svg.subpage-icon path[fill] {
    fill: ${colors.midnight};
  }
  &.active {
    border-top: 4px solid transparent;
    border-bottom: 4px solid ${colors.midnight};
  }
  & .body-small-text.product-name {
    opacity: 0.5;
  }
  & .body-medium-text.reduced-price {
    font-weight: 600;
    line-height: 1.67;
  }
  & .body-small-text.full-price {
    opacity: 0.5;
    text-decoration: line-through;
    line-height: 1.67;
  }
  & a {
    display: inline-flex;
  }
`;

NavItem.defaultProps = {
  isNavigationItem: true,
};
